export { default as buildLabelElement } from './utils/build-label-element';
export { default as getRange } from './utils/get-range';
export { default as pad } from './utils/pad';
export { default as unpad } from './utils/unpad';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-react-gauges/node_modules/@progress/kendo-charts/dist/es/gauges/utils.js
// module id = 561
// module chunks = 29